import React from 'react';
import Svg, {Path, Circle} from 'react-native-svg';

interface Props {
  size?: number;
  color?: string;
}

const NovaCategoryCheckIcon: React.FC<Props> = ({
  size = 14,
  color = '#2563EB',
}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Circle cx={12} cy={12} r={10} stroke={color} strokeWidth={2} />
    <Path
      d="M9 12l2 2 4-4"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default NovaCategoryCheckIcon;